import { render, staticRenderFns } from "./textContent-editor.vue?vue&type=template&id=51e57632&scoped=true&"
import script from "./textContent-editor.vue?vue&type=script&lang=js&"
export * from "./textContent-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e57632",
  null
  
)

export default component.exports